import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { RegisterFormCompanyComponent } from './register-form-company/register-form-company.component';
import { RegisterFormNaturalPersonComponent } from './register-form-natural-person/register-form-natural-person.component';
import { UserRoleIds } from 'src/app/models/security/user-role-enum';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styles: [],
  standalone: true,
  imports: [RegisterFormCompanyComponent, RegisterFormNaturalPersonComponent, CommonModule, CarouselComponent]
})
export class RegisterComponent implements OnInit {
  typePerson: number = UserRoleIds.Member;
  rolesId = UserRoleIds;

  authService = inject(AuthService);

  ngOnInit(): void {
    if(this.authService.isLoggedIn()){
      this.authService.doLoginNavigate();
    }
  }

  setTypePerson(type: number): void {
    this.typePerson = type;
  }

  uploadLogo(): void {
    document.getElementById('fileLogo')?.click();
  }

  uploadFoto(): void {
    document.getElementById('fileFoto')?.click();
  }

  uploadFile(): void {
    document.getElementById('fileDocReq')?.click();
  }
}
